import { FormGroup } from '@angular/forms';

export interface ParsedVisit {
  group: FormGroup;
  index: number;
  sortDate: Date;
}

export function normalizeVisitDate(raw: string): Date {
  const parts = raw.split('.');

  if (parts.length === 3) {
    return new Date(+parts[2], +parts[1] - 1, +parts[0]);
  }

  if (parts.length === 2) {
    return new Date(+parts[1], +parts[0] - 1, 1);
  }

  return new Date(+raw, 0, 1);
}

export function getParsedVisitsWithSortDate(visitsArray: FormGroup[]): ParsedVisit[] {
  return visitsArray
    .map((group, index) => {
      const rawDate = group.value.dateLeave?.trim() ?? '';
      return {
        group,
        index,
        sortDate: normalizeVisitDate(rawDate),
      };
    })
    .sort((a, b) => b.sortDate.getTime() - a.sortDate.getTime());
}

export function isSameVisitOrder(parsed: { index: number }[]): boolean {
  const currentOrder = parsed.map(p => p.index).join(',');
  const expectedOrder = [...parsed]
    .sort((a, b) => a.index - b.index)
    .map(p => p.index)
    .join(',');
  return currentOrder === expectedOrder;
}
